'use client'

import { useMemo, useState } from 'react'
import { ToolField, ToolResultCard, ToolResultRow, toolCurrency, toolFmt, toolNum } from './tool-inputs'

// Standard gypsum board is 1.2 m × 2.7 m = 3.24 m² (SA "rhino board"; a US 4×8 sheet
// is ~2.97 m² — swap BOARD_AREA for the US variant).
const BOARD_AREA = 1.2 * 2.7

export function DrywallCalculatorTool() {
  const [length, setLength] = useState('10')
  const [height, setHeight] = useState('2.7')
  const [sides, setSides] = useState('1')
  const [waste, setWaste] = useState('10')
  const [price, setPrice] = useState('220')

  const r = useMemo(() => {
    const area = toolNum(length) * toolNum(height) * Math.max(1, toolNum(sides))
    const areaWithWaste = area * (1 + toolNum(waste) / 100)
    const boards = Math.ceil(areaWithWaste / BOARD_AREA)
    return { area, boards, cost: boards * toolNum(price) }
  }, [length, height, sides, waste, price])

  return (
    <div className="grid gap-6 md:grid-cols-[1fr_380px] md:items-start">
      <div className="space-y-5 rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
        <div>
          <h2 className="text-sm font-semibold uppercase tracking-wide text-slate-500">Wall / partition</h2>
          <div className="mt-3 grid grid-cols-3 gap-3">
            <ToolField label="Length" value={length} onChange={setLength} unit="m" />
            <ToolField label="Height" value={height} onChange={setHeight} unit="m" />
            <ToolField label="Sides" value={sides} onChange={setSides} unit="×" hint="1 wall, 2 partition" />
          </div>
        </div>
        <div>
          <h2 className="text-sm font-semibold uppercase tracking-wide text-slate-500">Waste &amp; price</h2>
          <div className="mt-3 grid grid-cols-2 gap-3">
            <ToolField label="Waste allowance" value={waste} onChange={setWaste} unit="%" hint="10–15% typical" />
            <ToolField label="Board price" value={price} onChange={setPrice} unit="R/board" />
          </div>
        </div>
      </div>

      <ToolResultCard title="Your drywall estimate">
        <ToolResultRow label="Board area" value={`${toolFmt(r.area, 1)} m²`} />
        <ToolResultRow label="Boards to buy (incl. waste)" value={`${r.boards} boards`} />
        <ToolResultRow label="Estimated board cost" value={toolCurrency(r.cost)} strong />
      </ToolResultCard>
    </div>
  )
}
